export default __webpack_public_path__ + "static/media/confusionImg_2.4b1a18c7.webp";